import { AircraftVariants } from '@/types';

export const AIRCRAFT_FAMILIES = {
  B73F: '737Freighter',
  B74F: '747Freighter',
  B75F: '757Freighter',
  B76F: '767Freighter',
  B77F: '777Freighter',
  A30F: 'A300Freighter',
  A32F: 'A320Freighter',
  A33F: 'A330Freighter',
  A35F: 'A350Freighter',
};

export const AIRCRAFT_VARIANTS: AircraftVariants = {
  [AIRCRAFT_FAMILIES.B73F]: ['73F', '73K', '73P', '73X', '73Y'],
  [AIRCRAFT_FAMILIES.B74F]: ['74F', '74N', '74T', '74X', '74Y'],
  [AIRCRAFT_FAMILIES.B75F]: ['75F'],
  [AIRCRAFT_FAMILIES.B76F]: ['76X', '76Y'],
  [AIRCRAFT_FAMILIES.B77F]: ['77F', '77X', '773-F', '77W-SF'],
  [AIRCRAFT_FAMILIES.A30F]: ['ABF', 'ABY'],
  [AIRCRAFT_FAMILIES.A32F]: ['32F', '32X'],
  [AIRCRAFT_FAMILIES.A33F]: ['33F', '33X', '33Y'],
  [AIRCRAFT_FAMILIES.A35F]: ['35F'],
};
